import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

import "@popperjs/core";
import "bootstrap";
import "initializers/bootstrap";
import "initializers/rails";

// The document keeps the policy from the first response. Turbolinks later
// replaces this meta tag with the next response's nonce, which the browser
// will not accept, so later copies must reuse this value.
const cspNonce = document.querySelector('meta[name="csp-nonce"]')?.content;

if (cspNonce) {
  const createScriptElement = Turbolinks.Renderer.prototype.createScriptElement;

  // The browser strips nonce before Turbolinks copies a script into the new
  // page, so the copy has to receive the document nonce itself.
  Turbolinks.Renderer.prototype.createScriptElement = function (element) {
    const script = createScriptElement.call(this, element);

    if (script?.tagName === "SCRIPT" && !script.src) script.nonce = cspNonce;

    return script;
  };

  const installStylesheetElement = Turbolinks.ProgressBar.prototype.installStylesheetElement;

  // Width and opacity stay style attributes. The bar's style tag needs the
  // document nonce before it is inserted.
  Turbolinks.ProgressBar.prototype.installStylesheetElement = function () {
    this.stylesheetElement.nonce = cspNonce;
    installStylesheetElement.call(this);
  };
}

Rails.start();
Turbolinks.start();

window.bootstrap = require("bootstrap");

const application = Application.start();
const context = require.context("../controllers", true, /\.js$/);

application.debug = true;
application.load(definitionsFromContext(context));

window.Stimulus = application;
